import { ApiService } from "../..";

export const getUserLittleGroupState = (userId: string) => {
    return ApiService.baseAction(`little-group/${userId}/little_group_state`, {}, "get");
    
};